import React, { useState, useEffect, useRef } from "react";
import GridIcon from "../../../assets/icons/GridIcon";
import { productService } from "../../../services/product.service";
import "./Navbar.css";

const navCategories = [
  { name: "Smart Lithium Ion Batteries", category_id: "smart-li-ion-batteries" },
  { name: "Smart Lithium Phosphate Battery", category_id: "smart-lithium-phosphate-battery" },
  { name: "Scooty Batteries", category_id: "scooty-batteries" },
  { name: "Electric Cycle Batteries", category_id: "electric-cycle-batteries" },
  { name: "Smart Integrated Inverters", category_id: "smart-integrated-inverters" },
  { name: "BMS", category_id: "bms" },
  { name: "Bike Batteries", category_id: "bike-batteries" },
  { name: "Car Batteries", category_id: "car-batteries" },
  { name: "battery-chargers", category_id: "battery-chargers" }
];

const Navbar = ({ onNavigate, currentPage }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(navCategories[0].category_id);
  const [products, setProducts] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchProducts = async () => {
      const data = await productService.getAllProducts();
      setProducts(data);
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getPreviewProducts = () => {
    return products
      .filter((p) => p.category_id === hoveredCategory)
      .slice(0, 3);
  };

  const handleCategoryRedirect = (categoryId) => {
    setDropdownOpen(false);
    onNavigate(`shop?category=${categoryId}`);
    window.scrollTo(0, 0);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left" ref={dropdownRef}>
        <button
          className="categories-button"
          onClick={() => setDropdownOpen(!isDropdownOpen)}
        >
          <GridIcon /> All Categories
          <span className={`arrow ${isDropdownOpen ? "up" : "down"}`}></span>
        </button>

        {isDropdownOpen && (
          <div className="mega-menu">
            <div className="mega-left">
              {navCategories.map((category) => (
                <div
                  key={category.category_id}
                  className={`mega-category ${hoveredCategory === category.category_id ? "active" : ""}`}
                  onMouseEnter={() => setHoveredCategory(category.category_id)}
                  onClick={() => handleCategoryRedirect(category.category_id)}
                >
                  {category.name}
                </div>
              ))}
            </div>

            <div className="mega-right">
              {getPreviewProducts().map((product) => (
                <div
                  key={product._id}
                  className="mega-product-card"
                  onClick={() => {
                    setDropdownOpen(false);
                    onNavigate("product", product.product_id);
                  }}
                >
                  <img src={product.images?.[0]} alt={product.name} />
                  <p className="mega-product-name">{product.name}</p>
                  <span className="mega-product-price">
                    ₹{product.price_display}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="nav-links">
        <button
          type="button"
          onClick={() => onNavigate("home")}
          className={`nav-link ${currentPage === "home" ? "active" : ""}`}
        >
          Home
        </button>

        <button
          type="button"
          onClick={() => onNavigate("shop")}
          className={`nav-link ${currentPage === "shop" ? "active" : ""}`}
        >
          Shop
        </button>

        <button
          type="button"
          onClick={() => onNavigate("about-us")}
          className={`nav-link ${currentPage === "about-us" ? "active" : ""}`}
        >
          About us
        </button>

        <button
          type="button"
          onClick={() => onNavigate("contact")}
          className={`nav-link ${currentPage === "contact" ? "active" : ""}`}
        >
          Contact Us
        </button>

        <button
          type="button"
          onClick={() => onNavigate("warranty-check")}
          className={`nav-link ${currentPage === "warranty-check" ? "active" : ""}`}
        >
          Check Warranty
        </button>
      </div>
    </nav>
  );
};

export default Navbar;